import React from 'react';
import { Modal } from 'antd';
import type { ModalProps } from 'antd';

// ─── 타입 ─────────────────────────────────────────────────────────────────────

export interface AppModalProps extends Omit<ModalProps, 'mask'> {
  /**
   * 모달 외부 클릭 시 닫기 여부.
   * Ant Design 기본값(true)과 달리 프로젝트 전체는 false 를 기본으로 사용한다.
   * @default false
   */
  maskClosable?: boolean;
}

// ─── AppModal ─────────────────────────────────────────────────────────────────

/**
 * 프로젝트 공통 모달.
 *
 * Ant Design `Modal`을 직접 쓸 때마다 반복되던 옵션을 기본값으로 고정한다:
 *   - `mask={{ closable: false }}` → maskClosable={false}
 *   - `destroyOnClose` → true (언마운트 시 내부 상태 초기화)
 *
 * 사용 예:
 *   <AppModal title="엑셀로 카드 등록" open={open} onCancel={onClose} footer={[...]}>
 *     ...
 *   </AppModal>
 *
 *   <AppModal title="작업 진행 중" open={!!jobId} closable={false} footer={null}>
 *     ...
 *   </AppModal>
 */
export const AppModal: React.FC<AppModalProps> = ({
  maskClosable = false,
  destroyOnClose = true,
  children,
  ...rest
}) => (
  <Modal
    // antd 6 이름(mask.closable · destroyOnHidden) — 예전 이름은 지원 중단 경고를 렌더마다 찍어 테스트가 느려졌다.
    mask={{ closable: maskClosable }}
    destroyOnHidden={destroyOnClose}
    {...rest}
  >
    {children}
  </Modal>
);